import { Component, OnInit } from "@angular/core";
import { MessageService } from "../../services/message.service";
import { AiroService } from "../../services/airo.service";
import { Subscription } from "rxjs";
import { SurveyService } from "../../services/survey.service";
import { MatDialog } from "@angular/material/dialog";
import { ScorecardModalComponent } from "src/app/shared/components/scorecard-modal/scorecard-modal.component";

@Component({
  selector: "app-hubble-insights",
  templateUrl: "./hubble-insights.component.html",
  styleUrls: ["./hubble-insights.component.scss"],
})
export class HubbleInsightsComponent implements OnInit {
  vendorSummary: Array<any> = [
    {
      summary:
        "Carina demonstrates a strong performance overall, achieving an average score of 5. In the category of STRATEGIC PARTNERSHIP, Carina is tied in second place with an average score of 4.75. However, Carina's performance in the DELIVERY category is slightly lower, with an average of 4.4, indicating a potential area for improvement. In PEOPLE CAPITAL, Carina excels with an average score of 5, showcasing their strength in personnel-related attributes. Overall, Carina maintains robust scores across all categories, with exceptional capabilities in overall satisfaction and people capital but could further enhance delivery-related outcomes.",
      vendor_id: 62,
      vendor_name: "Carina",
    },
    {
      summary:
        "Antlia shows commendable performance with an average score of 5 in the OVERALL category, indicating high satisfaction from survey respondents. Like Carina, Antlia scores 4.75 in the STRATEGIC PARTNERSHIP category, illustrating their competence in forming effective partnerships. Antlia leads in the DELIVERY category, achieving the highest average score of 4.8, making it a notable strength for the vendor. In PEOPLE CAPITAL, Antlia maintains an excellent score of 5, suggesting strong capabilities in managing human resources. Antlia's strengths lie in overall satisfaction, delivery, and personnel management, marking them as a highly proficient vendor with consistently strong performances across key categories.",
      vendor_id: 56,
      vendor_name: "Antlia",
    },
  ];
  vendorInvestments: any;

  observable: Subscription;
  vendors: any;
  aiResponse: any;
  vendorData: any;
  dataLoaded: boolean;
  hasSurveyData: boolean = true;
  aggregatedData: any;

  constructor(
    private readonly airoService: AiroService,
    private readonly surveyService: SurveyService,
    private readonly messageService: MessageService,
    private readonly dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
    this.observable.unsubscribe();

    // this.browseAISubscription?.unsubscribe()
  }

  ngOnInit(): void {
    this.dataLoaded = false;
    this.observable = this.messageService
      .getHubbleInsightVendor()
      .subscribe((vendorData: Array<any>) => {
        this.dataLoaded = false;
        this.surveyService
          .getVendorBasedSurveyData(vendorData.map((vendor: any) => vendor.id))
          .subscribe((res: any) => {
            this.vendorData = res;
            if (res?.gdp_bvt_survey_response?.length === 0) {
              this.dataLoaded = true;
              this.hasSurveyData = false;
              return;
            }
            const payload = {
              survey_name: "GDP-BVT",
              vendors: vendorData,
              data: res.gdp_bvt_survey_response,
            };

            this.airoService.getToken().then(() => {
              this.airoService
                .getGDPBVTSummary(payload)
                .subscribe((summaryResponse: any) => {
                  console.log("Summary Response:", summaryResponse);
                  this.aggregatedData = vendorData.map((vendor: any) => {
                    return {
                      vendor,
                      investment: res.vendor_investments
                        .filter(
                          (investment: any) =>
                            investment.vendor_id === vendor.id
                        )
                        .map(
                          (investment: any) => investment.total_investment
                        )?.[0],
                      summary: summaryResponse.data
                        .filter(
                          (vendorSummary: any) =>
                            vendorSummary.vendor_id === vendor.id
                        )
                        .map(
                          (vendorSummary: any) => vendorSummary.summary
                        )?.[0],
                      vendorId: vendor.id,
                    };
                  });
                  this.dataLoaded = true;
                });
            });
          });
      });
  }

  openScoreCard(vendorId: any) {
    this.dialog.open(ScorecardModalComponent, {
      width: "70vw",
      maxHeight: "90vh",
      autoFocus: false,
      disableClose: true,
      data: { vendorId },
    });
  }
}
